import * as Yup from 'yup';
import { StepOvzFacilitiesForm } from './step-ovz-facilities-types';

export const stepOvzFacilitiesSchema = () =>
  Yup.object<StepOvzFacilitiesForm>().shape({
    ovzFacilities: Yup.array()
      .default([])
      .min(1, 'Vyberte alespoň jednu provozovnu OVZ'),
  });
